// freshworks.ts
let isLoaded = false;

export const loadFreshworks = () => {
  if (isLoaded) return;

  // 1️⃣ Setup settings
  window.fwSettings = {
    widget_id: 103000008446,
  };

  // 2️⃣ Stub function (same as their snippet)
  if (typeof window.FreshworksWidget !== "function") {
    const n = function () {
      n.q.push(arguments);
    };
    n.q = [];
    window.FreshworksWidget = n;
  }

  // 3️⃣ Inject script lazily
  const script = document.createElement("script");
  script.src = "https://euc-widget.freshworks.com/widgets/103000008446.js";
  script.async = true;

  document.body.appendChild(script);

  isLoaded = true;
};
